<div class="validation-errors-container p-6">
  <div class="flex items-center justify-between mb-6">
    <div>
      <h2 class="text-2xl font-bold text-gray-900 dark:text-white">Błędy Walidacji</h2>
      <p class="text-sm text-gray-600 dark:text-gray-400 mt-1">
        Faktury które nie przeszły walidacji przed wysyłką do KSeF
      </p>
    </div>
    <button 
      mat-raised-button 
      color="primary" 
      (click)="refresh()"
      [disabled]="isLoading"
    >
      <mat-icon svgIcon="tabler_outline:refresh"></mat-icon>
      Odśwież
    </button>
  </div>

  <div *ngIf="isLoading" class="flex justify-center items-center py-12">
    <mat-spinner diameter="50"></mat-spinner>
  </div>

  <div *ngIf="!isLoading && dataSource.length === 0" class="text-center py-12">
    <mat-icon 
      class="!w-16 !h-16 text-gray-400 mb-4" 
      svgIcon="tabler_outline:check-circle"
    ></mat-icon>
    <p class="text-lg text-gray-600 dark:text-gray-400">
      Brak błędów walidacji 🎉
    </p>
    <p class="text-sm text-gray-500 mt-2">
      Wszystkie faktury przeszły walidację pomyślnie
    </p>
  </div>

  <div *ngIf="!isLoading && dataSource.length > 0" class="bg-white dark:bg-gray-800 rounded-lg shadow overflow-hidden">
    <table mat-table [dataSource]="dataSource" class="w-full">

      <!-- Timestamp Column -->
      <ng-container matColumnDef="timestamp">
        <th mat-header-cell *matHeaderCellDef class="font-bold">Data</th>
        <td mat-cell *matCellDef="let error">
          {{ error.timestamp | date: 'dd.MM.yyyy HH:mm' }}
        </td>
      </ng-container>

      <!-- Document Number Column -->
      <ng-container matColumnDef="documentNumber">
        <th mat-header-cell *matHeaderCellDef class="font-bold">Numer Faktury</th>
        <td mat-cell *matCellDef="let error">
          <span class="font-medium">{{ error.documentNumber }}</span>
        </td>
      </ng-container>

      <!-- User Column -->
      <ng-container matColumnDef="user">
        <th mat-header-cell *matHeaderCellDef class="font-bold">Użytkownik</th>
        <td mat-cell *matCellDef="let error">
          <div *ngIf="error.user" class="text-sm">
            <a 
              [routerLink]="['/admin/users', error.user.id, 'info']"
              class="font-medium text-blue-600 dark:text-blue-400 hover:underline"
            >
              {{ error.user.firstName }} {{ error.user.lastName }}
            </a>
            <div class="text-xs text-gray-500">{{ error.user.companyName }}</div>
          </div>
          <span *ngIf="!error.user" class="text-gray-400">-</span>
        </td>
      </ng-container>

      <!-- Error Code Column -->
      <ng-container matColumnDef="errorCode">
        <th mat-header-cell *matHeaderCellDef class="font-bold">Kod Błędu</th>
        <td mat-cell *matCellDef="let error">
          <mat-chip class="font-mono text-xs" color="warn">
            {{ error.error?.code || 'VALIDATION_FAILED' }}
          </mat-chip>
        </td>
      </ng-container>

      <!-- Error Message Column -->
      <ng-container matColumnDef="errorMessage">
        <th mat-header-cell *matHeaderCellDef class="font-bold">Komunikat</th>
        <td mat-cell *matCellDef="let error">
          <div class="text-sm">
            {{ error.error?.message || 'Brak komunikatu' }}
          </div>
          <div *ngIf="error.error?.details?.length > 0" class="text-xs text-gray-500 mt-1">
            {{ error.error.details.length }} szczegół{{ error.error.details.length > 1 ? 'y' : '' }}
          </div>
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="font-bold">Akcje</th>
        <td mat-cell *matCellDef="let error">
          <button 
            mat-icon-button 
            color="primary" 
            (click)="openDetailsDialog(error)"
            matTooltip="Szczegóły błędu"
          >
            <mat-icon svgIcon="tabler_outline:search"></mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr 
        mat-row 
        *matRowDef="let row; columns: displayedColumns;"
        class="hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer"
        (click)="openDetailsDialog(row)"
      ></tr>
    </table>

    <div class="p-4 bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700">
      <p class="text-sm text-gray-600 dark:text-gray-400">
        Pokazano {{ dataSource.length }} z {{ totalCount }} błędów
      </p>
    </div>
  </div>
</div>

